module.exports = __webpack_public_path__ + "img/programme6.be83a78d.png";